/*
 * @Author: Zhouqi
 * @Date: 2025-12-15 10:07:40
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-04-20 17:46:49
 */
export const GUANCEYUN_VERSION = '1.7';
export const APP_VERSION = '3.8';
